import { PeriodAthlete, Rotation } from 'oas';

export const sanitiseRotations = (rotations: Rotation[] | undefined): Rotation[] => {
    if (!rotations?.length) {
        return [];
    }
    const rotationMap = new Map<string, Rotation>();
    rotations.forEach((rotation) => {
        // start + end time should be a unique key for a rotation
        const key = `${rotation.start_time_ms}-${rotation.end_time_ms ?? ''}`;
        if (!rotationMap.has(key)) {
            rotationMap.set(key, rotation);
        }
    });
    return Array.from(rotationMap.values());
};

export const sanitisePeriodAthletes = (athletes: PeriodAthlete[]): PeriodAthlete[] => {
    if (!athletes || athletes.length === 0) {
        return [];
    }

    const sanitisedAthletes: PeriodAthlete[] = [];
    // map of athleteId to index in sanitisedAthletes array
    const athleteMap = new Map<string, number>();

    athletes.forEach((athlete) => {
        const athleteId = athlete.athlete_id;
        if (!athleteId) {
            return;
        }
        const cleanedRotations = sanitiseRotations(athlete.rotations);

        if (!athleteMap.has(athleteId)) {
            athleteMap.set(athleteId, sanitisedAthletes.push({ ...athlete, rotations: cleanedRotations }) - 1);
        } else {
            // merge rotations into athlete
            const i = athleteMap.get(athleteId) as number;
            const merged = sanitiseRotations([...(sanitisedAthletes[i].rotations ?? []), ...cleanedRotations]);
            sanitisedAthletes[i] = { ...sanitisedAthletes[i], rotations: merged };
        }
    });
    return sanitisedAthletes;
};
